// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1WwjL","footer":"ModalUpdate_footer__1Z4xA"};